import React, {useEffect, useState} from 'react';
import {Box, FormControlLabel, Radio, RadioGroup} from '@mui/material';
import PropTypes from 'prop-types';
import EditMultiFieldsBuilder from './Shared/EditMultiFieldsBuilder';
import RichEditorResultText from './Shared/RichEditorResultText';
import {stripHtmlTags} from './AdditionalNotes';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

const SingleChoice = ({
                          index,
                          id,
                          fieldKey,
                          value,
                          onChange,
                          description,
                          isEditMode,
                          enableValidation,
                          options,
                          isFormArchived,
                          relatedComponent,
                          readonly,
                          placeholderValues,
                          accessLevel,
                          error,
                          audience,
                          recipientType
                      }) => {
    const [currentValue, setCurrentValue] = useState(description ?? '');

    useEffect(() => {
        setCurrentValue(description ?? '');
    }, [description]);

    const handleDescriptionChange = (nextValue) => {
        setCurrentValue(nextValue);

        if (!onChange) return;
        onChange({
            index,
            description: stripHtmlTags(nextValue),
            formattedDescription: nextValue,
        });
    };

    return (
        <Box sx={{mt: 2}}>
            {isEditMode
                ? (
                    <EditMultiFieldsBuilder
                        fieldKey={fieldKey}
                        onChange={onChange}
                        enableValidation={enableValidation}
                        description={description}
                        index={index}
                        options={options}
                        isFormArchived={isFormArchived}
                        relatedComponent={relatedComponent}
                        accessLevel={accessLevel}
                        currentDescription={currentValue}
                        setCurrentDescription={handleDescriptionChange}
                        audience={audience}
                        recipientType={recipientType}
                    />
                )
                : (
                    <Box key={`${description}-${value}`}>
                        <RichEditorResultText
                            id={id}
                            description={description}
                            placeholderValues={placeholderValues}
                            readonly={readonly}
                            enableValidation={enableValidation}
                            error={!!error}
                        />
                    <FormControl error={!!error} variant="standard">
                        <RadioGroup
                            value={value}
                            onClick={e => onChange({
                                id,
                                radioValue: e.target.value === value ? null : e.target.value
                            })}
                        >
                            {options.map((option, idx) => (
                                <FormControlLabel
                                    key={`${description}-option-${idx}`}
                                    sx={{
                                        '& .MuiTypography-root': {
                                            wordBreak: 'break-word',
                                            maxWidth: '800px',
                                        }
                                    }}
                                    value={option.id}
                                    control={<Radio size="small"/>}
                                    label={option.description}
                                />
                            ))}
                        </RadioGroup>
                        <FormHelperText>{error}</FormHelperText>
                    </FormControl>
                </Box>
                )}
        </Box>
    );
};

SingleChoice.propTypes = {
    id: PropTypes.string,
    fieldKey: PropTypes.string,
    value: PropTypes.string,
    index: PropTypes.number,
    options: PropTypes.array,
    description: PropTypes.string,
    enableValidation: PropTypes.bool,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    relatedComponent: PropTypes.object,
    readonly: PropTypes.bool,
    placeholderValues: PropTypes.object,
    accessLevel: PropTypes.number,
    error: PropTypes.string,
    audience: PropTypes.number,
    recipientType: PropTypes.string
};

export default SingleChoice;
